import DepartmentPlanCard from "../DepartmentsPlan/DepartmentPlanCard";
import usePlanBody from "../_shared/UserPlanBody/usePlanBody";
import { useDashboard } from "../../../lib/useDashboard";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/Auth/lib/useAuth';

function UserPlan() {
  const { loading, error, result } = usePlanBody("userPlan_isPeriod");
  const { dateStart, dateEnd, selectedDepartment } = useDashboard();
  const { user } = useAuth();
  const navigate = useNavigate();
  const opportunity = result?.opportunity ?? null;
  const profit = result?.profit ?? null;

  const hasData =
    opportunity != null || profit != null;

  if (!hasData && !loading) return null;

  const openAnalytics = () => {
    const departmentId = Number(selectedDepartment || user?.bx.department?.[0]?.id || 0);
    const userId = Number(user?.bx.bx_user.bx_id || 0);
    if (!dateStart || !dateEnd || !departmentId || !userId) return;
    const query = new URLSearchParams({
      scope: 'employee', departmentId: String(departmentId), userId: String(userId), dateStart, dateEnd,
    });
    navigate(`/SalePlan/analytics?${query.toString()}`);
  };

  return (
    <>
      <DepartmentPlanCard
        title="Личный план продаж"
        col={15}
        row={10}
        loading={loading}
        error={error}
        opportunity={opportunity}
        profit={profit}
        opportunityPlannedSales={result?.plannedSalesOpportunity ?? null}
        profitPlannedSales={result?.plannedSalesProfit ?? null}
        onClick={openAnalytics}
      />
    </>
  );
}

export default UserPlan;
